// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"c07bb913","246":"7ff32a2a","358":"76180912","464":"91d7cd43","878":"0525fd12","897":"faf02d1f","900":"1d01f478","960":"8f2cbb47"}[chunkId] + ".chunk.js";
};